import { render, staticRenderFns } from "./CheckStatus.vue?vue&type=template&id=067b4ade&"
import script from "./CheckStatus.vue?vue&type=script&lang=js&"
export * from "./CheckStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports